import Flickity from 'flickity';
import 'flickity-imagesloaded';
import { max } from 'lodash-es';
import { SliderCartItem } from './SliderCartItem';
import { SliderCartPromoTile } from './SliderCartPromoTile';

let monetateListenerInitialized = false;
let flickityInstance = null;
let currentItems = [];

function hideShowRecommendedHeader() {
  try {
    const notEmptyEls = document.querySelectorAll('[data-cart-header-not-empty]');
    const emptyEls = document.querySelectorAll('[data-cart-header-empty]');
    const isEmpty = window.cart?.item_count <= 0;
    notEmptyEls.forEach((el) => (el.style.display = isEmpty ? 'none' : 'block'));
    emptyEls.forEach((el) => (el.style.display = isEmpty ? 'block' : 'none'));
  } catch (error) {
    console.log(error);
  }
}

function createFlickityInstance(sliderWrapper, itemsLength) {
  // Destroy old instance if any
  if (flickityInstance && typeof flickityInstance.destroy === 'function') {
    flickityInstance.destroy();
  }

  flickityInstance = new Flickity(sliderWrapper, {
    imagesLoaded: true,
    cellAlign: window.innerWidth > 767 ? 'left' : 'right',
    contain: true,
    draggable: true,
    dragThreshold: 3,
    initialIndex: window.innerWidth > 767 ? 0 : itemsLength,
    prevNextButtons: !(window.innerWidth > 1116 && itemsLength < 5),
  });
}

export function SliderCartAddons(props) {
  const container = document.createElement('div');
  container.className = 'SliderCartAddOnsContainer';

  function handleLoad(event) {
    const items = event.detail.monetateData;
    currentItems = items;
    const title = event.detail.title;

    container.innerHTML = '';

    if (title?.trim()) {
      const heading = document.createElement('div');
      heading.className = 'SliderCartAddOns__headings';
      const h2 = document.createElement('h2');
      h2.textContent = title;
      heading.appendChild(h2);
      container.appendChild(heading);
    }

    if (!items || items.length === 0) return;

    const sliderWrapper = document.createElement('div');
    sliderWrapper.className = 'SliderCartAddons';
    container.appendChild(sliderWrapper);

    let variantAvailabilities = {};

    items.forEach((item) => {
      if (!item.Child_Attributes) return;

      const firstVariant = item.Child_Attributes[0];
      const comparePrices = item.Child_Attributes.map((v) => v.compare_at_price);
      const comparePriceMax = max(comparePrices);

      const variantsWithAvailability = item.Child_Attributes.map((variant) => {
        const available = variantAvailabilities[variant.variant_id] || variant.available;
        return { ...variant, available };
      });

      const productUrl = item.Detail_URL.replace('https://windsor-us.myshopify.com', '');

      const tileProps = {
        id: item.item_group_id,
        pid: item.ID,
        title: item.Title,
        product_url: productUrl,
        thumb_url: firstVariant.image_url,
        thumb_alt: item.Title,
        price: firstVariant.price,
        price_compare: firstVariant.compare_at_price,
        price_compare_max: comparePriceMax,
        tags: item.tags.split(','),
        variants: variantsWithAvailability,
        product: item,
        options: item.options,
        colorOptions: item.color,
        sizeOptions: item.size,
        isRec: true,
        selectedColor: item.selectedColor,
      };

      const tile = SliderCartItem(tileProps);
      if (tile) sliderWrapper.appendChild(tile);
    });

    if (window.innerWidth < 767 && props.promo) {
      const promoEl = SliderCartPromoTile(props.promo);
      if (promoEl) sliderWrapper.appendChild(promoEl);
    }

    hideShowRecommendedHeader();
    window.dispatchEvent(new Event('resize'));

    createFlickityInstance(sliderWrapper, items.length);
  }

  // Recreate Flickity with updated options on resize
  function handleResize() {
    if (!currentItems.length) return;

    const sliderWrapper = container.querySelector('.SliderCartAddons');
    if (sliderWrapper) {
      createFlickityInstance(sliderWrapper, currentItems.length);
    }
  }

  if (!monetateListenerInitialized) {
    document.addEventListener('monetateLoadedcart1_rr', handleLoad);
    document.addEventListener('monetateLoadedemptycart1_rr', handleLoad);
    window.addEventListener('resize', handleResize);
    monetateListenerInitialized = true;
  }

  return container;
}
